export interface NewsItem {
  id: string;
  type: 'news';
  title: string;
  summary: string;
  cover: string;
  author: string;
  publishedAt: string;
  category: string;
  tags: string[];
  views: number;
  body: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'news-01',
    type: 'news',
    title: '暑期档原创动画电影票房破纪录，小成本团队成最大黑马',
    summary: '一部没有大牌配音、没有超级宣发的原创动画，靠口碑一路逆袭，成为今年暑期档讨论度最高的作品之一。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20glowing%20movie%20clapperboard%20and%20golden%20film%20reels%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%20entertainment%20theme%2C%20no%20text&width=800&height=450&seq=news-cover-01&orientation=landscape',
    author: '一起艹资讯组',
    publishedAt: '2026-10-12',
    category: '影视',
    tags: ['影视', '票房', '动画'],
    views: 128400,
    body: [
      '今年暑期档，一部由小型工作室制作的原创动画电影意外走红。上线首周排片并不占优，但凭借观众口口相传，第二周开始上座率持续走高，最终跻身档期前列。',
      '业内人士分析，这部作品的成功并不依赖流量明星，而是把预算集中在了故事打磨与手绘质感上。影片中大量温暖的生活细节，让不少观众在社交平台自发分享观后感。',
      '随着讨论热度攀升，围绕这部影片的二创、表情包与同人作品不断涌现，也让更多人开始关注原创动画团队的生存状态。',
    ],
  },
  {
    id: 'news-02',
    type: 'news',
    title: '三大舞台阵容全曝光，今年秋季音乐节玩法升级',
    summary: '主舞台、电子舞台与民谣小舞台同步官宣，主办方还新增了露营区与深夜电台环节。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20concert%20stage%20with%20colorful%20lights%20and%20silhouette%20crowd%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%20festival%20theme%2C%20no%20text&width=800&height=450&seq=news-cover-02&orientation=landscape',
    author: '演出观察',
    publishedAt: '2026-10-11',
    category: '活动',
    tags: ['活动', '音乐节', '现场'],
    views: 96300,
    body: [
      '备受关注的秋季音乐节正式公布完整阵容。与往年相比，今年主办方把舞台拆分为三个区域，分别对应摇滚、电子与民谣，观众可以按兴趣自由流动。',
      '除了演出本身，现场还增设了露营区、黑胶市集与深夜电台环节，试图把一天的演出延伸为完整的生活方式体验。',
      '不少乐迷表示，这种「分区 + 沉浸」的模式让观演节奏更从容，也更容易发现此前没听过的新乐队。',
    ],
  },
  {
    id: 'news-03',
    type: 'news',
    title: '短剧集新趋势：用八集讲完一个完整的故事',
    summary: '越来越多的创作者选择短剧集形态，节奏更紧凑，也更容易在移动端被完整看完。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20smartphone%20playing%20a%20short%20drama%20with%20play%20button%20and%20abstract%20frames%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-03&orientation=landscape',
    author: '剧集前瞻',
    publishedAt: '2026-10-10',
    category: '影视',
    tags: ['影视', '短剧', '趋势'],
    views: 75400,
    body: [
      '过去动辄四五十集的剧集模式正在被重新审视。越来越多创作者开始尝试八到十二集的短剧集，把故事讲得更集中。',
      '短剧集的优势在于节奏紧凑，观众在通勤、午休等碎片时间就能完整看完一集，也更容易形成连续追看的习惯。',
      '有编剧认为，集数变少并不意味着内容变薄，反而对剧本的结构和人物弧光提出了更高要求。',
    ],
  },
  {
    id: 'news-04',
    type: 'news',
    title: '综艺同质化困局：观众到底想看到什么样的真实',
    summary: '当慢综艺与竞技综艺都进入疲劳期，观众对「真实感」的渴望正在成为新的分水岭。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20television%20screen%20with%20abstract%20variety%20show%20elements%20and%20geometric%20shapes%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-04&orientation=landscape',
    author: '一起艹资讯组',
    publishedAt: '2026-10-09',
    category: '影视',
    tags: ['影视', '综艺', '评论'],
    views: 68200,
    body: [
      '打开任何一个平台，你都能看到相似的综艺结构：固定的流程、熟悉的套路、可预期的笑点，这让不少观众产生了审美疲劳。',
      '有制作人坦言，真正的问题不在于形式，而在于是否愿意呈现「未经设计的真实」。观众并不排斥低成本的场景，却对刻意编排的情绪格外敏感。',
      '未来一段时间，如何在安全的框架里保留真实感，或许是综艺破局的关键。',
    ],
  },
  {
    id: 'news-05',
    type: 'news',
    title: '独立音乐人的小场地时代：百人场里唱出万人合唱',
    summary: '不去大场地，独立音乐人反而在几十到几百人的空间里，找到了最真实的连接。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20an%20intimate%20small%20music%20venue%20with%20microphone%20and%20warm%20stage%20light%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-05&orientation=landscape',
    author: '声音现场',
    publishedAt: '2026-10-08',
    category: '活动',
    tags: ['活动', '音乐', '独立'],
    views: 54700,
    body: [
      '越来越多的独立音乐人把巡演重心放在了几十到几百人的小场地。没有炫目的舞台，观众离表演者只有几步之遥。',
      '一位乐手表示，小场地能听到听众的呼吸和跟唱，这种即时的反馈是大舞台难以替代的。很多歌曲的情绪，正是在这样的空间里被打磨出来。',
      '当演出结束，乐迷和乐手常常聚在场外继续聊天，音乐之外的连接同样珍贵。',
    ],
  },
  {
    id: 'news-06',
    type: 'news',
    title: '幕后揭秘：一部网剧的诞生到底需要多少工种',
    summary: '从编剧、美术到场务、灯光，片尾那几百个名字，构成了一个你想象不到的完整世界。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20film%20set%20with%20camera%20boom%20lights%20and%20storyboard%20cards%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-06&orientation=landscape',
    author: '一起艹幕后',
    publishedAt: '2026-10-07',
    category: '影视',
    tags: ['影视', '幕后', '行业'],
    views: 49800,
    body: [
      '很多人看剧时习惯快进片尾，但其实那几分钟里滚动过的名字，才是一部作品真正的骨架。',
      '美术组负责让每一件道具看起来都合理，灯光组要在有限的场地里造出时间与情绪，场务组则是所有拍摄顺利进行的保障。',
      '一位执行制片人笑称，导演只是那个「最后拍板」的人，真正让机器转起来的，是身后几十个配合默契的工种。',
    ],
  },
  {
    id: 'news-07',
    type: 'news',
    title: '从剧场到大银幕：舞台剧改编为何总是「又爱又怕」',
    summary: '舞台剧有天然的戏剧张力，但改编成电影却常常水土不服，问题究竟出在哪。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20theater%20stage%20with%20red%20curtain%20and%20spotlight%20beside%20a%20cinema%20screen%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-07&orientation=landscape',
    author: '剧作观察',
    publishedAt: '2026-10-06',
    category: '影视',
    tags: ['影视', '舞台剧', '改编'],
    views: 41500,
    body: [
      '舞台剧和电影虽然是近亲，却是两种截然不同的语言。舞台靠台词和现场张力推动，电影则更依赖镜头与空间的调度。',
      '不少改编作品失败的原因，是直接照搬了舞台的节奏，却忽略了电影观众对画面信息的要求。',
      '成功的案例往往敢于重构：保留原作的精神内核，同时用影像重新讲述，而不是把摄像机架在第一排。',
    ],
  },
  {
    id: 'news-08',
    type: 'news',
    title: '虚拟偶像开唱：当技术遇到情感，观众买账了吗',
    summary: '全息投影、实时动捕、千人同屏互动，虚拟演出的技术越来越成熟，但情感连接仍是关键。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20holographic%20virtual%20idol%20figure%20with%20neon%20lines%20and%20stage%20glow%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-08&orientation=landscape',
    author: '一起艹科技',
    publishedAt: '2026-10-05',
    category: '活动',
    tags: ['活动', '虚拟偶像', '科技'],
    views: 38900,
    body: [
      '虚拟演出的技术门槛正在快速降低，实时动捕与渲染让虚拟角色的动作越来越自然。',
      '但业内人士指出，技术只是基础，观众真正在意的，是这个虚拟形象是否拥有能让人记住的「人格」与故事。',
      '在几场口碑较好的演出中，主办方往往会设计大量粉丝共创环节，让观众觉得自己也是演出的一部分。',
    ],
  },
  {
    id: 'news-09',
    type: 'news',
    title: '年度口碑盘点：那些被低估的小成本佳作',
    summary: '没有大制作，没有热搜，却靠扎实的叙事在小范围内收获了极高评价。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20stack%20of%20film%20tickets%20with%20a%20golden%20star%20badge%20on%20soft%20gradient%20background%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=news-cover-09&orientation=landscape',
    author: '一起艹编辑部',
    publishedAt: '2026-10-04',
    category: '八卦',
    tags: ['八卦', '盘点', '口碑'],
    views: 33600,
    body: [
      '每年都会有一些作品，因为宣传预算有限而没能走进大众视野，却在看过的人心里留下了很深的印记。',
      '这次盘点挑选了几部小成本佳作，它们没有流量加持，却在剧本、表演与美术上展现了惊人的完成度。',
      '如果你也厌倦了千篇一律的大制作，不妨从这份片单开始，重新发现「小而美」的魅力。',
    ],
  },
];